export default __webpack_public_path__ + "static/sqft-85bace3e8228947d3141eedde10370e2.svg";